export interface BuildConfig {
  header: {
    links: {
      home: string;
      contact_us: string;
      faq: string;
      bookRepair: string;
    };
  };
  footer: {
    links: {
      terms: string;
      privacy: string;
      accessibility: string;
    };
  };
  dd_guarantee: string;
  domain: string;
  pr: string;
  common: string;
  recaptchaSiteKey: string;
  landingModalEnabled: boolean;
  isCovidNoticeEnabled: boolean;
  isBVOverrideEnabled: boolean;
}
